<a class="settings-container" href="{{settingUrl}}">
  <span><zui-icon class="settings-icon" icon="settings"> </zui-icon> </span>
  <span class="text">
    {{this.translations.overview.settings.text | translate}}
  </span>
</a>
